module.exports = __webpack_public_path__ + "img/icon_1.ee94b728.png";